<template>
    <b-modal id="modal-multibanco" centered class="modal-multibanco" no-close-on-backdrop>
        <div class="modal-multibanco-itens">
            <button class="modal-multibanco-itens-close" @click="$bvModal.hide('modal-multibanco')">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.78" height="21.15" viewBox="0 0 18.78 21.15">
                    <g id="Grupo_1753" data-name="Grupo 1753" transform="translate(-411.263 -553.556)">
                        <g id="Grupo_1413" data-name="Grupo 1413" transform="translate(403.688 564.131) rotate(-45)">
                            <path id="União_2" data-name="União 2" d="M18.15,0,9.075,7.779ZM0,0,9.075,7.779Z"
                                transform="translate(0 12.834) rotate(-45)" fill="none" stroke="var( --green-medium)"
                                stroke-linejoin="round" stroke-width="3" />
                        </g>
                        <g id="Grupo_1593" data-name="Grupo 1593" transform="translate(437.617 564.131) rotate(135)">
                            <path id="União_2-2" data-name="União 2" d="M18.15,0,9.075,7.779ZM0,0,9.075,7.779Z"
                                transform="translate(0 12.834) rotate(-45)" fill="none" stroke="var( --green-medium)"
                                stroke-linejoin="round" stroke-width="3" />
                        </g>
                    </g>
                </svg>
            </button>
            <div class="modal-multibanco-itens-body">
                <div class="modal-multibanco-itens-body-title">
                    <h2>A sua encomenda foi submetida com sucesso</h2>
                </div>
            </div>
        </div>
        <!-- <div class="modal-multibanco-itens-reference">
            <p>O número de referência é o xxxxx.</p>
        </div> -->
        <div class="modal-multibanco-itens-box">
            <div class="icon">
                <img src="@/assets/img/icons/icon-multibanco.png" alt="Logo MultiBanco" />
            </div>
            <div class="entity">
                <div class="lines">
                    <p>Entidade:</p>
                    <span>{{ multiBanco.paymentEntity }}</span>
                </div>
                <div class="lines">
                    <p>Referência:</p>
                    <span>{{ multiBanco.reference }}</span>
                </div>
                <div class="lines">
                    <p>Valor:</p>
                    <span>{{ price }} €</span>
                </div>
            </div>
        </div>
        <div class="modal-multibanco-itens-preference">
            <p>
                Enviámos um email para o seu endereço de registo com esta
                informação.
            </p>
            <p>Obrigada pela sua preferência.</p>
        </div>
        <div class="modal-multibanco-itens-btns">
            <button class="btn-send" @click="redirOrders()">
                Continuar
            </button>
        </div>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: ["multiBanco", "price"],
    // watch: {
    //     multiBanco: function (newVal, oldVal) {
    //         // watch it
    //         console.log("multiBanco: ", newVal, " | was: ", oldVal);
    //     },
    // },
    methods: {
        redirOrders() {
            this.$bvModal.hide('modal-multibanco');
            this.$router.push('/orders');
        }
    }
};
</script>

<style lang="scss">
#modal-multibanco {

    .modal-header,
    .modal-footer {
        display: none;
    }

    .modal-dialog {
        max-width: 945px;
        margin: auto !important;

        @media screen and (max-width: 991px) {
            max-width: 384px;
        }
    }

    .modal-content {
        border-radius: 0;
        border: 0;
    }

    .modal-body {
        padding: 5.6rem 7.5rem 5rem 7.5rem;
        max-height: 945px;
        display: flex;
        flex-direction: column;

        @media (max-width: 991px) {
            padding: 50px 20px;
            height: 754px;
        }
    }
}

.modal-multibanco {
    &-itens {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;

        &-close {
            width: 62px;
            height: 53px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--white);
            border: 1px solid var(--green-medium);
            border-radius: 10px;
            transition: 500ms;

            @media (max-width: 991px) {
                top: 20px;
                right: 20px;
                width: 40px;
                height: 40px;

                svg {
                    max-width: 15px;
                }
            }

            &:hover,
            &:focus {
                opacity: 0.6;
            }
        }

        &-body {
            max-height: 345px;
            overflow-y: auto;

            &-title {
                h2 {
                    font-size: 30px;
                    font-weight: bold;
                    color: var(--green-dark);

                    @media (max-width: 991px) {
                        font-size: 22px;
                    }
                }
            }

            .content-opinion-user {
                padding: 30px 0px;
                border-bottom: 1px solid #b7b8b8;
            }
        }

        &-reference {
            margin-top: 3.5rem;

            p {
                font-family: "Font Regular";
                font-size: 2.5rem;
                color: var(--green-dark);

                @media (max-width: 991px) {
                    font-size: 1.8rem;
                }
            }
        }

        &-box {
            margin-top: 3rem;
            margin-bottom: 3rem;
            width: 79rem;
            height: 32rem;
            border: 1px solid var(--green-medium);
            border-radius: 1rem;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;

            @media (max-width: 991px) {
                flex-direction: column;
            }

            >.icon {
                display: flex;
                justify-content: center;
                width: 50%;

                @media (max-width: 991px) {
                    width: 100%;
                }

                img {
                    max-width: 10rem;

                    @media (max-width: 991px) {
                        max-width: 7rem;
                    }
                }
            }

            >.entity {
                width: 50%;
                display: flex;
                flex-direction: column;
                text-align: left;

                @media (max-width: 991px) {
                    margin-top: 2rem;
                    width: 100%;
                }

                >.lines {
                    display: flex;
                }

                p {
                    font-family: "Font Regular";
                    font-size: 2.5rem;
                    color: #303030;
                    width: 50%;

                    @media (max-width: 991px) {
                        font-size: 1.8rem;
                        margin-left: 1rem;
                        width: 100%;
                    }
                }

                span {
                    font-family: "Font Bold";
                    font-size: 2.5rem;
                    color: #303030;
                    width: 50%;

                    @media (max-width: 991px) {
                        font-size: 1.8rem;
                        width: 100%;
                    }
                }
            }
        }

        &-preference {
            margin-bottom: 4rem;

            p {
                font-family: "Font Regular";
                font-size: 2.5rem;
                color: var(--green-dark);

                @media (max-width: 991px) {
                    font-size: 1.8rem;
                }
            }
        }

        &-btns {
            .btn-send {
                width: 122px;
                height: 45px;
                background: var(--green-medium);
                border: 1px solid var(--green-medium);
                border-radius: 10px;
                box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
                font-size: 18px;
                font-family: "Font Regular";
                color: var(--white);
                transition: 500ms;

                &:hover,
                &:focus {
                    cursor: pointer;
                    background: var(--white);
                    color: var(--green-medium);
                }
            }
        }
    }
}
</style>